import { useEffect, useState } from "react";
import { api } from "../lib/api";
import PostCard from "../components/PostCard";
import LeftSidebar from "../components/LeftSidebar";
import SuggestedPlayers from "../components/SuggestedPlayers";
import TrendingPlayers from "../components/TrendingPlayers";
import CreatePostCard from "../components/CreatePostCard";
import { useAuth } from "../context/AuthContext";

export default function FeedPage() {
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("following");

  useEffect(() => {
    setLoading(true);
    const url = tab === "following" && user ? "/posts/feed" : "/posts/explore";
    api.get(url).then(({ data }) => {
      setPosts(data);
      setLoading(false);
    });
  }, [tab, user]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 lg:grid-cols-12 gap-6" data-testid="feed-page">
      <div className="lg:col-span-3 space-y-4 lg:sticky lg:top-24 self-start">
        <LeftSidebar />
      </div>

      <div className="lg:col-span-6 space-y-4">
        <CreatePostCard />

        <div className="flex items-center gap-1 border-b border-[#262626]">
          <TabButton active={tab === "following"} onClick={() => setTab("following")} testid="feed-tab-following">
            Following
          </TabButton>
          <TabButton active={tab === "explore"} onClick={() => setTab("explore")} testid="feed-tab-explore">
            Explore
          </TabButton>
        </div>

        {loading ? (
          <div className="space-y-3">
            {[0, 1, 2].map((i) => (
              <div key={i} className="bg-[#121212] border border-[#262626] rounded-sm h-56 animate-pulse" />
            ))}
          </div>
        ) : posts.length === 0 ? (
          <div data-testid="feed-empty" className="bg-[#121212] border border-[#262626] p-8 text-center rounded-sm">
            <h3 className="font-display text-2xl text-white uppercase tracking-tight">Nothing here yet</h3>
            <p className="text-sm text-[#a3a3a3] mt-2">
              {tab === "following"
                ? "Follow other players on Discover to fill your feed."
                : "Be the first to post a match highlight."}
            </p>
          </div>
        ) : (
          posts.map((p) => (
            <PostCard key={p.id} post={p} onDelete={(id) => setPosts((ps) => ps.filter((x) => x.id !== id))} />
          ))
        )}
      </div>

      <div className="lg:col-span-3 lg:sticky lg:top-24 self-start space-y-4">
        <TrendingPlayers />
        <SuggestedPlayers />
      </div>
    </div>
  );
}

function TabButton({ active, onClick, children, testid }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`px-4 py-3 text-xs uppercase tracking-widest transition-colors border-b-2 ${
        active
          ? "text-white border-white"
          : "text-[#737373] border-transparent hover:text-white"
      }`}
    >
      {children}
    </button>
  );
}
